<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    const dispatch = createEventDispatcher()
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import { faAngleLeft, faEdit, faFileImport, faPlusCircle, faSave, faSearch, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
    import Content from '../../_common/content.svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import { ServicesRepository } from '../../../modules/posApi/services/services.repository'
    import { ServicesService } from '../../../modules/posApi/services/services.service'
    import { Service } from '../../../modules/posApi/services/service'
    import type { CreateServiceDto } from '../../../modules/posApi/services/dto/create-service.dto'
    import type { UpdateServiceDto } from '../../../modules/posApi/services/dto/update-service.dto'
    import dayjs from 'dayjs'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import Zact from '../../_common/z/zact.svelte'
    import Zbutton from '../../_common/z/zbutton.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import ZContainer from '../../_common/z/z-container.svelte'
    import ZContainerCol from '../../_common/z/z-container-col.svelte'
    import AudienceFileImport from '../../automacao/audience/audience-file-import.svelte'
    import ZentitySelect from '../../_common/z/zentity-select.svelte'
    import { ConfigService } from '../../../modules/infra/config'
    // ##############################################################################################################

    const entityId = 'serviceId'

    export let form: boolean = false
    export let serviceId: string = null
    const rep = new ServicesRepository()
    const service = new ServicesService(rep)
    let entity: Service = new Service()

    const volumeUnitOptions = [
        { value: 'un', label: 'un' },
        { value: 'ml', label: 'ml' },
        { value: 'l', label: 'l' },
        { value: 'gotas', label: 'gotas' },
        { value: 'mg', label: 'mg' },
        { value: 'g', label: 'g' },
        { value: 'kg', label: 'kg' },
        { value: 'ui', label: 'ui' },
        { value: 'cm', label: 'cm' },
    ]

    let csvData = []
    let csvTypes = []
    csvTypes.push({ value: 'name', label: 'Nome do produto' })
    csvTypes.push({ value: 'value', label: 'Valor' })
    csvTypes.push({ value: 'comissionPercentage', label: 'Comissão do vendedor %' })
    //csvTypes.push({ value: 'comissionPercentageAttendant', label: 'Comissão do atendente %' })
    csvTypes.push({ value: '-', label: 'Outro / Não importar' })
    let validImport = false

    async function editEntity(id: string) {
        try {
            show = true
            entity = new Service()
            entity = await service.getOne(id, { category: true })
            console.log('product', entity)
            step = 2
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function newEntity() {
        entity = new Service()
        entity.balance = true
        step = 2
    }

    async function createEntity(returnToStep1 = true, blockDuplicity = false) {
        try {
            show = true
            const dto: CreateServiceDto = {
                consulting: entity.consulting,
                comissionFixed: entity.comissionFixed || 0,
                comissionPercentage: entity.comissionPercentage || 0,
                comissionCosts: entity.comissionCosts || 0,
                comissionFixedAttendant: entity.comissionFixedAttendant || 0,
                comissionPercentageAttendant: entity.comissionPercentageAttendant || 0,
                comissionCostsAttendant: entity.comissionCostsAttendant || 0,
                duration: entity.duration,
                name: entity.name,
                price: entity.price,
                costs: entity.costs || 0,
                balance: entity.balance,
                type: 'product',
                stock: 0,
                description: '',
                public: false,
                scheduleInterval: 0,
                schedulers: [],
                schedulersOnline: [],
                needResource: false,
                documents: entity.documents,
                expirationDays: undefined,
                blockDuplicity: blockDuplicity,
                serviceCategoryId: entity.category?.serviceCategoryId || entity.serviceCategoryId,
                minStock: entity.minStock,
                volumeUnit: entity.volumeUnit,
            }
            entity = await service.create(dto)
            if (form) {
                sendClose()
                return
            }
            if (returnToStep1) {
                await loadEntities()
            }
        } catch (error) {
            evaluateError(error)
        } finally {
            if (returnToStep1) {
                show = false
            }
        }
    }

    function sendClose() {
        dispatch('close')
    }

    async function updateEntity() {
        try {
            show = true
            const dto: UpdateServiceDto = {
                comissionFixed: entity.comissionFixed || 0,
                comissionPercentage: entity.comissionPercentage || 0,
                comissionCosts: entity.comissionCosts || 0,
                comissionFixedAttendant: entity.comissionFixedAttendant || 0,
                comissionPercentageAttendant: entity.comissionPercentageAttendant || 0,
                comissionCostsAttendant: entity.comissionCostsAttendant || 0,
                duration: entity.duration,
                name: entity.name,
                price: entity.price,
                consulting: entity.consulting,
                costs: entity.costs,
                balance: entity.balance,
                description: '',
                public: false,
                scheduleInterval: 0,
                schedulers: [],
                schedulersOnline: [],
                documents: entity.documents,
                expirationDays: undefined,
                serviceCategoryId: entity.category?.serviceCategoryId || entity.serviceCategoryId,
                minStock: entity.minStock,
                volumeUnit: entity.volumeUnit,
            }
            await service.update(entity[entityId], dto)
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function saveEntity() {
        if (entity[entityId]) {
            updateEntity()
        } else {
            createEntity()
        }
    }

    async function loadEntities() {
        try {
            show = true
            step = 1
            entities = await service.getAll({ type: 'product' })
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await service.remove(entity[entityId])
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function showEntities() {
        step = 1
    }

    let show = false
    let step = 1
    let entities = []

    onMount(async () => {
        await loadEntities()
        if (form) {
            if (serviceId) {
                await editEntity(serviceId)
            } else {
                newEntity()
            }
        }
    })

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Produtos'
        grid.subtitle = ''
        grid.cols.push(new GridCol({ content: 'Produto' }))
        grid.cols.push(new GridCol({ content: 'Alteração', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Valor', size: 2, type: GridColTypeEnum.float_2 }))
        grid.cols.push(new GridCol({ content: 'Com. vendedor', size: 2, type: GridColTypeEnum.float_2 }))
        //grid.cols.push(new GridCol({ content: 'Com. atendente', size: 2, type: GridColTypeEnum.float_2 }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            const btnPerson = new GridButton({
                callback: () => editEntity(item.serviceId),
                icon: faEdit,
                label: 'Editar',
            })
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.name })
            line.slots.push({ content: item.updatedAt })
            line.slots.push({ content: item.price })
            line.slots.push({ content: item.comissionPercentage })
            //line.slots.push({ content: item.comissionPercentageAttendant })
            line.slots.push({ content: [btnPerson] })
            grid.lines.push(line)
        }
    }

    function importFile() {
        step = 3
    }

    async function saveImport() {
        if (!validImport) {
            window.error('Dados inválidos. Informe todos os campos.')
            return
        }
        console.log('loaded data', csvData)
        let success = 0
        for (const data of csvData) {
            if (!data['name']) continue
            let price = data['value'] || '0'
            price = parseFloat(price?.replaceAll('R$', '').trim())
            entity = new Service()
            entity.consulting = false
            entity.comissionFixed = 0
            entity.comissionPercentage = parseFloat(data['comissionPercentage']) || 0
            entity.comissionCosts = 0
            entity.comissionFixedAttendant = 0
            entity.comissionPercentageAttendant = parseFloat(data['comissionPercentageAttendant']) || 0
            entity.comissionCostsAttendant = 0
            entity.duration = 0
            entity.name = data['name']
            entity.price = price
            entity.costs = 0
            entity.balance = true
            entity.type = 'product'
            entity.status = 100
            entity.stock = 0
            entity.public = false
            entity.scheduleInterval = 0
            entity.schedulers = []
            entity.schedulersOnline = []
            entity.description = ''
            entity.needResource = false
            await createEntity(false, true)
            success++
        }
        await loadEntities()
        window.alert('Importação de ' + success + ' produtos concluída.')
    }
</script>

<LoadSpinner {show} />
{#if !show}
    {#if step === 1}
        <Content footer={true}>
            <Zact>
                <div class="spacer" />
                {#if window.store.token.permissions.tools.services.write}
                    <Zbutton color="secondary" icon={faFileImport} label="Importar" on:click={importFile} />
                    <Zbutton color="primary" icon={faPlusCircle} label="Novo produto" mobileHideLabel={true} on:click={newEntity} />
                {/if}
            </Zact>
            <Zgrid class="h-space" {grid} />
        </Content>
    {/if}
    {#if step === 3}
        <Content footer={true}>
            <Zact>
                {#if !form}
                    <Zbutton color="secondary" icon={faAngleLeft} label="Voltar" on:click={showEntities} />
                {/if}
                <div class="spacer" />
                {#if window.store.token.permissions.tools.services.write}
                    <Zbutton color="primary" icon={faSave} label="Importar" loading={show} disabled={show} on:click={saveImport} />
                {/if}
            </Zact>

            <div class="px-3">
                <Zframe class="h-space" title="Importação">
                    <AudienceFileImport
                        types={csvTypes}
                        bind:data={csvData}
                        bind:valid={validImport}
                        instructions="Selecione um arquivo XLSX ou CSV com os dados a serem importados."
                    />
                </Zframe>
            </div>
        </Content>
    {/if}
    {#if step === 2}
        <Content footer={true}>
            <Zact>
                {#if !form}
                    <Zbutton color="secondary" icon={faAngleLeft} label="Voltar" on:click={showEntities} />
                {/if}
                <div class="spacer" />
                {#if window.store.token.permissions.tools.services.write}
                    {#if !!entity[entityId]}
                        <Zbutton color="red" icon={faTrashAlt} label="Excluir" disabled={show} on:click={removeEntity} />
                    {/if}
                    <Zbutton color="primary" icon={faSave} label="Salvar" loading={show} disabled={show} on:click={saveEntity} />
                {/if}
            </Zact>

            <Zframe class="h-space" title="Produto">
                <ZContainer>
                    <Zinput size={4} sizeM={12} label="Nome" bind:value={entity.name} />
                    <Zinput size={4} sizeM={12} type="number" label="Valor {window.configs.currency}" bind:value={entity.price} />
                    <ZContainerCol size={4} sizeM={12}>
                        <ZentitySelect fonte="categoriaServico" label="Categoria" bind:value={entity.category} />
                    </ZContainerCol>
                    <Zinput size={4} skin="outline" type="toggle" label="Controlar estoque deste produto" bind:value={entity.balance} />
                    <Zinput
                        size={4}
                        sizeM={12}
                        type="number"
                        label="Estoque mínimo (alerta)"
                        help="A dashboard de estoque sinaliza quando a quantidade em estoque chegar nesse valor ou menos. Deixe em branco pra não alertar."
                        bind:value={entity.minStock}
                    />
                    <Zinput size={4} sizeM={12} type="select" label="Unidade de medida" options={volumeUnitOptions} bind:value={entity.volumeUnit} />
                </ZContainer>
            </Zframe>
            <Zframe class="mt-3" title="Comissão do Vendedor">
                <ZContainer>
                    <Zinput size={4} sizeM={12} type="number" label="Comissão %" bind:value={entity.comissionPercentage} />
                    <Zinput size={4} sizeM={12} type="number" label="Comissão Fixa ({window.configs.currency})" bind:value={entity.comissionFixed} />
                    <Zinput size={4} sizeM={12} type="number" label="Outros custos a descontar" bind:value={entity.comissionCosts} />
                </ZContainer>
            </Zframe>
        </Content>
    {/if}
{/if}

<style>
</style>
